import React from "react";
import determinants from "./Determinants.pdf";

export default function Determinants() {
  return (
    <div>
      <iframe
        src={determinants}
        width="100%"
        className="h-screen"
        title="Determinants"
      />
    </div>
  );
}
